"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.map");

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _AccordionItem = _interopRequireDefault(require("./AccordionItem"));

var _safeMapAndCloneChildren = _interopRequireDefault(require("../utils/safeMapAndCloneChildren"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function hasNewActiveItems(prevActiveKey, activeKey) {
  return !(0, _lodash["default"])(prevActiveKey, activeKey);
}

var propTypes = {
  activeKey: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].string), _propTypes["default"].string]),
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  singleOpen: _propTypes["default"].bool,
  size: _propTypes["default"].string,
  theme: _propTypes["default"].string
};
var defaultProps = {
  activeKey: null,
  children: null,
  className: null,
  singleOpen: true,
  size: '',
  theme: ''
};

var Accordion = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Accordion, _Component);

  function Accordion(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.getActiveItemsFromProps = function () {
      var children = _this.props.children;

      var activeList = _react["default"].Children.map(children, function (_ref, index) {
        var key = _ref.key;

        if (_this.isActiveKey(key)) {
          return index;
        }

        return -1;
      });

      if (activeList) {
        return activeList.filter(function (index) {
          return index >= 0;
        });
      }

      return [];
    };

    _this.isActiveKey = function (key) {
      var activeKey = _this.props.activeKey;
      return activeKey && (activeKey === key || Array.isArray(activeKey) && activeKey.includes(key));
    };

    _this.toggleActive = function (index) {
      var singleOpen = _this.props.singleOpen;
      var activeItems = _this.state.activeItems;

      if (activeItems.includes(index)) {
        _this.setState({
          activeItems: activeItems.filter(function (i) {
            return index !== i;
          })
        });
      } else if (singleOpen) {
        _this.setState({
          activeItems: [index]
        });
      } else {
        _this.setState({
          activeItems: activeItems.concat(index)
        });
      }
    };

    _this.state = {
      activeItems: _this.getActiveItemsFromProps()
    };
    return _this;
  }

  var _proto = Accordion.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var activeKey = this.props.activeKey;

    if (hasNewActiveItems(prevProps.activeKey, activeKey)) {
      var newActiveItems = this.getActiveItemsFromProps();
      this.setState({
        // eslint-disable-line react/no-did-update-set-state
        activeItems: newActiveItems
      });
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        size = _this$props.size,
        theme = _this$props.theme,
        children = _this$props.children,
        className = _this$props.className,
        singleOpen = _this$props.singleOpen,
        activeKey = _this$props.activeKey,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["size", "theme", "children", "className", "singleOpen", "activeKey"]);

    var activeItems = this.state.activeItems;
    var classes = (0, _classnames["default"])(className, {
      'grv-accordion': size !== 'md' && size !== 'sm',
      'grv-accordion--dark': theme === 'dark',
      'grv-accordion--md': size === 'md',
      'grv-accordion--sm': size === 'sm'
    });
    var childrenWithAddedProps = (0, _safeMapAndCloneChildren["default"])(children, function (child, index) {
      return {
        active: activeItems.includes(index),
        index: index,
        toggleActive: _this2.toggleActive
      };
    });
    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, otherProps, {
      className: classes
    }), childrenWithAddedProps);
  };

  return Accordion;
}(_react.Component);

Accordion.propTypes = propTypes;
Accordion.defaultProps = defaultProps;
Accordion.Item = _AccordionItem["default"];
var _default = Accordion;
exports["default"] = _default;